import { useI18n } from 'builder/hooks/useI18n'
import { ButtonTheme, ButtonV2 } from 'builder/components/Button'
import { DialogModalV2 } from 'builder/components/DialogModal'

import { ActionModalContainer } from './styles'

type Props = {
  isLoading: boolean
  onCloseModal: () => void
  onConfirmModal: () => void
}

const TRANSLATION = 'builder.job_tracking.auto_apply.auto_tailoring.modal'

export const SkipAutoTailoringModal = ({ isLoading, onCloseModal, onConfirmModal }: Props) => {
  const { i18n } = useI18n()
  return (
    <DialogModalV2
      title={i18n.t(`${TRANSLATION}.header`)}
      subtitle={i18n.t(`${TRANSLATION}.description`)}
      onClose={onCloseModal}
    >
      <ActionModalContainer>
        <ButtonV2 isDisabled={isLoading} onClick={onCloseModal} theme={ButtonTheme.ghost}>
          {i18n.t(`${TRANSLATION}.cancel`)}
        </ButtonV2>
        <ButtonV2 isLoading={isLoading} onClick={onConfirmModal}>
          {i18n.t(`${TRANSLATION}.confirm`)}
        </ButtonV2>
      </ActionModalContainer>
    </DialogModalV2>
  )
}
